/**
 * @packageDocumentation
 * @module StockChartModule
 */
declare var require: any;
import { Component, OnInit, Input, QueryList, ViewChildren, ViewChild, Output, EventEmitter } from '@angular/core';
import * as Highcharts from 'highcharts/highstock';
// import StockModule from 'highcharts/modules/stock';
// import ExportingModule from 'highcharts/modules/exporting';
// import SunsetTheme from 'highcharts/themes/sunset.src.js';
// import * as HC_customEvents from 'highcharts-custom-events';

import { Subscription, Subject, forkJoin, BehaviorSubject, config } from 'rxjs';
import { isEmptyObject, isEmptyField, isEmptyArray, isSameArray, convertToInt } from '../stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';
import { StockChartService } from '../stock-chart.service';
import { StockChartConfig, ChartApplicationConfig, StockChartRenderConfig, StockChartOptions, StockChartApplicationAPIConfig, StockChartApplicationAPICompareConfig } from './stock-chart-model';
import { themes } from './stock-chart.cnst';
import { NgbModal, NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { SmaModelComponent } from '../sma-model/sma-model.component';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { defaultChartOptions } from './stock-chart.cnst';
import { StockChartDataService } from '../stock-chart-shared/stock-chart-shared-services/stock-chart-data.service';
import { StockChartCustomizableService } from '../stock-chart-customizable.service';
import { StockChartGeographicalDataService } from '../stock-chart-geographical-data.service';
@Component({
  // tslint:disable-next-line: component-selector
  selector: 'vl-stock-chart',
  templateUrl: './stock-chart.component.html',
  styleUrls: ['./stock-chart.component.scss']
})
export class StockChartComponent implements OnInit {
  @ViewChildren(NgbDropdown) childDropdown: QueryList<NgbDropdown>;
  @ViewChild(NgbDropdown,{
    static:false
  }) indicatorDropdown: NgbDropdown;
  /**
  * stock chart config as Input
  */
  @Input() stockChartConfig: StockChartConfig;
  @Output() configDataEmitter = new EventEmitter<any>();
  stockChartId: string;
  // stockChartConfig: StockChartConfig = JSON.parse(JSON.stringify(StockConfig));
  themeConfig = themes;
  byDefaultFilterCount = 1;

  // update variables start
  updateRequireFields = ['primary'];
  updatedFieldsArray = [];
  allUpdateFieldArray = ['primary'];
  updatedRequiredObject = {
    primary: true,
    secondary: false,
    compare: false
  };
  updatedSubject: Subject<any> = new Subject<any>();
  // update variables end

  chartOrder = ['primary', 'secondary', 'sma'];
  smaValue: any = {};
  getHeaders = Object.keys;


  // HighChartDependencies ['all'];
  Highcharts: typeof Highcharts = Highcharts;
  showChart = false;
  stockChartRenderConfig;
  updateFlag = false;

  // kickStart Dependencies
  kickStartRequiredArray: string[] = [];
  kickStartRequiredObject: any = {};
  kickStartSubject = new Subject<any>();
  kickStartSubscription = new Subject();

  // filter Variables Start
  filterSubscription: Subscription;
  stockCharFilterData: any = {};
  filterAllowedChangedFields = [];

  // date Picker Subscription
  datePickerSubscription: Subscription;
  stockChartDatePickerData: any = {};
  datePickerAllowedChangedFields = [];


  /** Shadab sir suggestion Starts */
  indicatorsConfig: { [key: string]: StockChartRenderConfig } = {};
  primaryCharts: any[] = [];
  secondaryCharts: any[] = [];
  primaryForkArray: any = [];
  primaryForkArrayNames: string[] = [];
  secondaryForkArray: any = [];
  secondaryForkArrayNames: string[] = [];

  applicationDataStore: any = {};
  chartIndexStore: any = {};

  otherSubscriptions: { [key: string]: Subscription } = {};
  otherSubscriptionsData: { [key: string]: any } = {};

  /** Shadab sir suggestion ends */

  // Router Subscription
  routerSubscription: Subscription;

  /** Unit related variables */
  chartUnits = {
    primary: '',
    secondary: ''
  };
  /** Unit related variables end */

  chartUnitYAxisIndex: {
    primary: { [key: string]: number },
    secondary: { [key: string]: number }
  } = {
      primary: {},
      secondary: {}
    };

  /** single api with multi application data variables */
  dataAPIs = [];
  /** single api with multi application data variables Ends */

  /** Id related variables */

  subscriptionsInProgress = true;

  // destroy subject here
  private destroySubject = new Subject<any>();

  // loader things
  loaderId: any = {};

  // geographical state object
  geographicalStateObject: any = {};



  constructor(
    private stockChartService: StockChartService,
    private dataService: StockChartDataService,
    private ngbModal: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private ngxLoader: NgxUiLoaderService,
    private stockChartCustomService: StockChartCustomizableService,
    private stockChartGeoService: StockChartGeographicalDataService
  ) {

  }
  /**
  * Angular On Init method
  */
  ngOnInit() {
    if (isEmptyField(this.stockChartConfig) || isEmptyObject(this.stockChartConfig)) {
      return;
    }
    Highcharts.setOptions({
      time: {
      useUTC: false,
      timezone: 'Asia/Kolkata'
      }
      });
    this.subscriptionsInProgress = true;
    this.stockChartId = this.stockChartConfig.chartId;
    this.updateGeographicalStateObject();
    this.stockChartConfig.chartOptions = this.dataService.deepMerge(defaultChartOptions, this.stockChartConfig.chartOptions);
    this.stockChartService.getIndicatorsConfig(this.dataService.deepClone(this.stockChartConfig), this.geographicalStateObject)
      .subscribe(data => {
        // console.log("\n data ", data);
        [this.stockChartConfig, this.indicatorsConfig] = data;
        this.byDefaultFilterCount = this.stockChartService.getByDefaultFilterCount(this.stockChartConfig.filterConfig);
        this.stockChartConfig.kickStartRequired = this.stockChartConfig.kickStartRequired ? this.stockChartConfig.kickStartRequired : [];
        this.handleStockChartIdMethods();
        if (this.stockChartConfig.routerConfig && this.stockChartConfig.routerConfig.routeChangeInvoke) {
          this.routerSubscription = this.router.events.subscribe(event => {
            // console.log("\n event \n", event);
            if (event instanceof NavigationEnd) {
              this.resetApplicationDataStore();
              this.initMethods();
            }
          });
        }
      });
  }
  /**
  * will initialize the geographical state things
  */
  updateGeographicalStateObject() {
    if (!isEmptyField(this.stockChartConfig.geographicalConfig)) {
      const geographicObj = this.stockChartConfig.geographicalConfig;
      const paramType = geographicObj.paramType ? geographicObj.paramType : 'queryParams';
      const location = this.route.snapshot[paramType][geographicObj.locationField];
      // const hierarchyId = this.route.snapshot[paramType][geographicObj.hierarchyField];
      if (!isEmptyField(location)) {
        if (geographicObj.automate) {
          const serviceConfigObj = {
            location: true,
            parent: true,
            child: true
          };
          this.geographicalStateObject = this.stockChartGeoService.extractLocationInformation(serviceConfigObj, location, geographicObj.hierarchyId);
        }
      } else {
        this.geographicalStateObject.location = geographicObj.currentLocation;
        this.geographicalStateObject.parent = geographicObj.currentParent;
        this.geographicalStateObject.child = geographicObj.currentChild;
      }
    }
  }
  /**
  * Will Initialize the subjects based on ID's
  */
  handleStockChartIdMethods() {
    this.loaderId.primary = this.stockChartId + 'primary';
    this.loaderId.secondary = this.stockChartId + 'secondary';
    this.setChartDefaultConfig();
    this.removegapsbetweenBarsRainfall();
    this.createServiceSubjects();
    this.handleSubscriptions();
    this.handleUpdateSubscription();
    this.subscriptionsInProgress = false;
  }

  removegapsbetweenBarsRainfall(){
    if(this.stockChartConfig.chartId == 'RainfallMIS' || this.stockChartConfig.chartId == 'RAINFALLGIS')
    this.stockChartRenderConfig.plotOptions.column.grouping = false;
    }
  /**
  * Will create the subjects based on ID's
  */
  createServiceSubjects() {
    this.stockChartService.createStockChartSubject(this.stockChartId);
    if (this.stockChartConfig.kickStartRequired && this.stockChartConfig.kickStartRequired.length > 0) {
      this.stockChartConfig.kickStartRequired.forEach(element => {
        if (!this.stockChartService.initSubjects[this.stockChartId]) {
          this.stockChartService.initSubjects[this.stockChartId] = {};
        }
        this.stockChartService.initSubjects[this.stockChartId][element] = new BehaviorSubject<boolean>(false);
      });
    }
  }
  /**
  * Angular Destroy function
  * will unsubscribe and clear the data
  */
  ngOnDestroy() {
    if (!!this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    // this.stockChartService.resetFilterData();
    // this.stockChartService.resetDatePickerData(this.stockChartId);
    // this.stockChartService.resetConfigSubjects(this.stockChartId);
    this.stockChartService.clearAllSubjectsForChart(this.stockChartId);
    if (!isEmptyField(this.filterSubscription)) {
      this.filterSubscription.unsubscribe();
    }
    if (!isEmptyField(this.datePickerSubscription)) {
      this.datePickerSubscription.unsubscribe();
    }
    if (!isEmptyField(this.kickStartSubscription)) {
      this.kickStartSubscription.unsubscribe();
    }
    for (const subscription of Object.keys(this.otherSubscriptions)) {
      this.otherSubscriptionsData[subscription] = {};
      this.otherSubscriptions[subscription].unsubscribe();
    }
  }

  /**
  * All the other subscription means any other component subscription in the stock chart service will get subscribed here
  */
  handleOtherSubscriptions() {
    this.stockChartConfig.otherSubscriptions.forEach(subscriptionString => {
      this.otherSubscriptions[subscriptionString] = this.stockChartService[subscriptionString].subscribe(data => {
        this.otherSubscriptionsData[subscriptionString] = data;
        this.initMethods();
      });
    });
  }


  /**
  * Update subscription here means whether all the charts in the stock chart are updated or not
  */
  handleUpdateSubscription() {
    this.updatedSubject
      .subscribe(data => {
        if (this.updatedFieldsArray.indexOf(data) === -1) {
          this.updatedFieldsArray.push(data);
        }
        if (isSameArray(this.updatedFieldsArray, this.updateRequireFields)) {
          this.updatedFieldsArray = ['primary'];
          this.updateRequireFields = ['primary'];
          if (this.stockCharFilterData.secondaryApplication) {
            this.updatedFieldsArray.push('secondary');
            this.updateRequireFields.push('secondary');
          }
          this.updateChartConfig();
        }
      });
  }

  /**
  * will handle the major subscription like filter and the date
  */
  handleSubscriptions() {
    this.kickStartRequiredArray = this.stockChartConfig.kickStartRequired;
    if (this.kickStartRequiredArray.length == 0) {
      this.initMethods();
    } else {
      this.kickStartRequiredArray.forEach((element) => {
        this.kickStartRequiredObject[element] = false;
      });
      this.kickStartSubject.subscribe(data => {
        let kickStart = true;
        Object.values(data).forEach(value => {
          if (isEmptyField(value) || value === false) {
            kickStart = false;
          }
        });
        if (kickStart) {
          this.initMethods();
        }
      });
      this.subscribeToKickStartComponents();
    }
  }

  /**
  * child function of handleSubscriptions
  */
  subscribeToKickStartComponents() {
    this.kickStartRequiredArray.forEach(element => {
      if (element == 'filter') {
        this.stockChartService.createFilterSubject(this.stockChartId);
        this.stockChartService.initSubjects[this.stockChartId][element].subscribe(data => {
          if (data) {
            this.filterSubscription = this.stockChartService.filterFormSubjects[this.stockChartId]
              .subscribe(data => {
                if (isEmptyObject(data)) {
                  return;
                }
                this.stockCharFilterData = data.data;
                if (this.kickStartRequiredObject.filter) {
                  if (!isEmptyArray(data.changedFields)) {
                    // for now writing a logic for single change
                    this.filterValueChange(data.changedFields[0], data.configObject[data.changedFields[0]]);
                  }
                }
                // const hasToChange = this.isNeedToChange(data, 'filter');

                // kick start for the first time
                if (!isEmptyObject(this.kickStartRequiredObject) && !isEmptyField(this.kickStartRequiredObject.filter) && !this.kickStartRequiredObject.filter) {
                  this.kickStartRequiredObject.filter = true;
                  this.kickStartSubject.next(this.kickStartRequiredObject);
                }
              });
          }
        });
      } else if (element === 'date') {
        this.stockChartService.createDatePickerSubject(this.stockChartId);
        this.stockChartService.initSubjects[this.stockChartId][element].subscribe(data => {
          if (data) {
            this.datePickerSubscription = this.stockChartService.datePickerSubjects[this.stockChartId]
              .subscribe(data => {
                if (isEmptyObject(data)) {
                  return;
                }
                this.stockChartDatePickerData = data;
                if (this.kickStartRequiredObject.date) {
                  this.resetApplicationDataStore();
                  this.initMethods();
                }
                // kick start for the first time
                if (!isEmptyObject(this.kickStartRequiredObject) && !isEmptyField(this.kickStartRequiredObject.date) && !this.kickStartRequiredObject.date) {
                  this.kickStartRequiredObject.date = true;
                  this.kickStartSubject.next(this.kickStartRequiredObject);
                }
              });
          }
        })
      }
    });
  }

  /**
  * will return whether the initMethod need to call or not
  * @param data data with changed fields
  * @param component component type whether filter | date
  */
  isNeedToChange(data, component) {
    const fieldsChanged = !isEmptyObject(data.changedFields) ? data.changedFields : [];
    const allowedFields = component === 'filter' ? this.filterAllowedChangedFields : this.datePickerAllowedChangedFields;
    let hasToChange = false;
    if (fieldsChanged.length > 0) {
      fieldsChanged.forEach(field => {
        if (!hasToChange && allowedFields.indexOf(field) !== -1) {
          hasToChange = true;
        }
      });
    }
    return hasToChange;
  }

  /**
  * reset the update related arrays
  */
  resetUpdatedArrays() {
    this.updateRequireFields = ['primary'];
    this.updatedFieldsArray = [];
  }


  /**
  * Init Methods will update the what fields required to start the chart
  * and will call the respective methods based on selection
  */
  initMethods(from?) {
    this.processIndicatorData(from);
    const inputArray: string[] = [];
    if (this.primaryCharts.length > 0) {
      inputArray.push('primary');
      if (this.updateRequireFields.indexOf('primary') === -1) {
        this.updateRequireFields.push('primary');
      }
      if (this.allUpdateFieldArray.indexOf('primary') === -1) {
        this.allUpdateFieldArray.push('primary');
      }
    } else {
      this.chartUnits.primary = '';
      if (this.updateRequireFields.indexOf('primary') !== -1) {
        this.updateRequireFields.splice(this.updateRequireFields.indexOf('primary'), 1);
      }
      if (this.allUpdateFieldArray.indexOf('primary') !== -1) {
        this.allUpdateFieldArray.splice(this.updateRequireFields.indexOf('primary'), 1);
      }
    }
    if (this.secondaryCharts.length > 0) {
      inputArray.push('secondary');
      if (this.updateRequireFields.indexOf('secondary') === -1) {
        this.updateRequireFields.push('secondary');
      }
      if (this.allUpdateFieldArray.indexOf('secondary') === -1) {
        this.allUpdateFieldArray.push('secondary');
      }
    } else {
      this.chartUnits.secondary = '';
      if (this.updateRequireFields.indexOf('secondary') !== -1) {
        this.updateRequireFields.splice(this.updateRequireFields.indexOf('secondary'), 1);
      }
      if (this.allUpdateFieldArray.indexOf('secondary') !== -1) {
        this.allUpdateFieldArray.splice(this.updateRequireFields.indexOf('secondary'), 1);
      }
    }
    this.callAPIBasedOnInput(inputArray);
  }

  createYAxisForChart(unit, renderer, applicationConfig: ChartApplicationConfig) {
    if (isEmptyField(this.chartUnitYAxisIndex[renderer])) {
      this.chartUnitYAxisIndex[renderer] = {};
    }
    if (!isEmptyField(this.chartUnitYAxisIndex[renderer][unit])) {
      return;
    }
    const currentUnitLength = Object.keys(this.chartUnitYAxisIndex[renderer]);
    let yAxisObj: any = {
      labels: {
        align: 'left',
        useHTML: true,
        // padding: '5'
      }
    };
    if (currentUnitLength.length > 0) {
      yAxisObj.opposite = false;
      delete yAxisObj.labels.align;
      yAxisObj.gridLineWidth = 0;
    }
    if (renderer === 'primary') {
      if (this.secondaryCharts.length === 0) {
        yAxisObj.height = '100%';
        if (isEmptyField(yAxisObj.resize)) {
          yAxisObj.resize = {};
        }
        yAxisObj.resize.enabled = false;
      } else {
        yAxisObj.height = '80%';
        if (isEmptyField(yAxisObj.resize)) {
          yAxisObj.resize = {};
        }
        yAxisObj.resize.enabled = true;
      }
    } else {
      yAxisObj.top = '80%';
      yAxisObj.height = '20%',
        yAxisObj.offset = 0;
    }

    if (this.stockChartConfig.chartOptions.yAxis.labelsAlignment === 'left') {
      yAxisObj.opposite = false;
      if (!yAxisObj.labels) {
        yAxisObj.labels = {};
      }
      yAxisObj.labels.align = 'right';
    }
    if (this.stockChartConfig.chartOptions.yAxis.unitsBesideLabel) {
      yAxisObj.labels.format = '{value} ' + unit;
    }
    if (this.stockChartConfig.chartOptions.yAxis.showApplicationAsTitle) {
      yAxisObj.title = {};
      yAxisObj.title.text = applicationConfig.title;
    }
    if (this.stockChartConfig.chartOptions.yAxis.unitAsTitle) {
      if (isEmptyField(yAxisObj.title)) {
        yAxisObj.title = {};
      }
      if (!isEmptyField(yAxisObj.title.text)) {
        yAxisObj.title.text = yAxisObj.title.text + ' (' + unit + ')';
      } else {
        yAxisObj.title.text = unit;
      }
    }
    let controller = this;
    if (this.stockChartConfig.chartOptions.yAxis.labelsFormatter) {
      yAxisObj.labels.formatter = function () {
        if (controller.stockChartConfig.chartOptions.yAxis.labelsFormatter.functionName) {
          try {
            const formatter = controller.stockChartCustomService[controller.stockChartConfig.chartOptions.yAxis.labelsFormatter.functionName](this.value, unit, controller.stockChartConfig.chartOptions.yAxis);
            return formatter;
          } catch (e) {
            console.log('Y axis label formatter function not exists');
          }
        } else if (controller.stockChartConfig.chartOptions.yAxis.labelsFormatter.formatter) {
          return controller.stockChartConfig.chartOptions.yAxis.labelsFormatter.formatter;
        }
      }
    }
    this.stockChartRenderConfig.yAxis.push(yAxisObj);
    this.chartUnitYAxisIndex[renderer][unit] = this.stockChartRenderConfig.yAxis.length - 1;
  }

  /**
  * will instantiate all the required config array from the indicators config
  */
  processIndicatorData(from?) {
    this.clearChartData(from);
    // console.log("\n In processIndicatorData \n ");
    for (const application of Object.keys(this.indicatorsConfig)) {
      const applicationData = this.indicatorsConfig[application];
      const applicationConfig = this.stockChartConfig.applicationConfig[application];
      if (applicationData.visible) {
        if (applicationData.renderer === 'primary') {
          this.primaryCharts.push(application);

        } else {
          this.secondaryCharts.push(application);
        }
      }
    }
    for (const application of Object.keys(this.indicatorsConfig)) {
      const applicationData = this.indicatorsConfig[application];
      const applicationConfig = this.stockChartConfig.applicationConfig[application];
      if (applicationData.visible) {
        const unitObject = this.verifyUnitObject(applicationData);
        const apiId = applicationConfig.apiConfig.apiId;
        let apiIdIndex = -1;
        if (!isEmptyField(apiId)) {
          apiIdIndex = this.dataAPIs.indexOf(apiId);
          if (apiIdIndex === -1) {
            this.dataAPIs.push(apiId);
          } else {
            console.log('API Index already existed');
          }
        }
        this.createYAxisForChart(applicationData.unit, applicationData.renderer, applicationConfig);

        // if (!unitObject.isSameUnit) {
        // const message = `${applicationData.renderer} chart units is ${unitObject.prevUnit} and ${applicationData.title} Unit is ${applicationData.unit}`;
        // this.dataService.showToastMessage(message, 'error');
        // applicationData.visible = false;
        // continue;
        // }
        if (applicationData.renderer === 'primary') {
          if (!isEmptyField(this.applicationDataStore[application]) && !isEmptyObject(this.applicationDataStore[application])) {
            this.addOrRemoveIndicatorCharts(application);
          } else {
            const apiConfig = this.getPostDataForApplication(application);
            this.primaryForkArray.push(this.stockChartService.getDataFromAPIConfig(this.stockChartId, apiConfig, apiId, true));
            this.primaryForkArrayNames.push(application);
          }
        } else {
          if (this.stockChartConfig.chartOptions.secondaryChart) {
            if (!isEmptyField(this.applicationDataStore[application]) && !isEmptyObject(this.applicationDataStore[application])) {
              this.addOrRemoveIndicatorCharts(application);
            } else {
              const apiConfig = this.getPostDataForApplication(application);
              this.secondaryForkArray.push(this.stockChartService.getDataFromAPIConfig(this.stockChartId, apiConfig, apiId, true));
              this.secondaryForkArrayNames.push(application);
            }
          } else {
            applicationData.visible = false;
          }
        }
      } else {
        this.addOrRemoveIndicatorCharts(application);
      }
    }
    if (this.primaryCharts.length === 0 && this.secondaryCharts.length === 0) {
      this.updateChartConfig();
    }
  }
  /**
  * will return the unitObject which will provide the unit is same or not for a single chart
  * @param config renderConfig for an application
  * @param chartAxis chart whether it's primary / secondary
  */
  verifyUnitObject(config: StockChartRenderConfig) {
    const unitObject = {
      isSameUnit: false,
      prevUnit: this.chartUnits[config.renderer],
      currentUnit: config.unit,
      applicationTitle: config.title
    };
    if (isEmptyObject(this.chartUnits[config.renderer])) {
      unitObject.isSameUnit = true;
    } else {
      if (unitObject.prevUnit === unitObject.currentUnit) {
        unitObject.isSameUnit = true;
      }
    }
    if (unitObject.isSameUnit) {
      this.chartUnits[config.renderer] = unitObject.currentUnit;
    }
    return unitObject;
  }
  /**
  * reset the units
  */
  resetUnits() {
    this.chartUnits = {
      primary: '',
      secondary: ''
    };
  }



  /**
  * will call the related functions ex: primary, secondary
  * @param input input array which contains the list of function need to execute ex: [primary, secondary]
  */
  callAPIBasedOnInput(input: string[]) {
    input.forEach(value => {
      switch (value) {
        case 'primary':
          this.ngxLoader.startLoader(this.loaderId.primary);
          this.processPrimaryChart();
          break;
        case 'secondary':
          this.ngxLoader.startLoader(this.loaderId.secondary);
          this.processSecondaryChart();
          break;
      }
    });
  }

  /**
  * will call the related functions ex: primary, secondary
  * @param input input array which contains the list of function need to execute ex: [primary, secondary]
  */
  callServiceBasedOnInput(input: string[], changeFor) {
    input.forEach(value => {
      switch (value) {
        case 'primary':
          this.formatPrimaryChart(changeFor);
          break;
        case 'secondary':
          // this.getSecondaryChartData();
          this.formatSecondaryChart(changeFor);
          break;
      }
    });
  }
  /**
  * format the chart data from service config for primary chart
  * @param changeFor the application which is format for
  */
  formatPrimaryChart(changeFor) {
    if (this.primaryCharts.length == 0) {
      this.updatedSubject.next('primary');
    } else {
      const subscriptionArray = [];
      this.primaryCharts.forEach(chart => {
        const serviceConfig = this.stockChartConfig.applicationConfig[chart].serviceConfig[changeFor];
        const applicationConfig = this.stockChartConfig.applicationConfig[chart];
        // if (applicationConfig.unitConversion) {
        if (isEmptyField(serviceConfig.paramObject)) {
          serviceConfig.paramObject = {};
        }
        serviceConfig.paramObject = this.addFieldsToPostData(serviceConfig.paramObject, serviceConfig.additionalServiceParams, 'applicationAdditionalServiceParams');
        serviceConfig.paramObject.fromUnit = this.chartUnits && this.chartUnits.primary;
        subscriptionArray.push(this.stockChartCustomService[serviceConfig.functionName](this.applicationDataStore[chart], serviceConfig.paramObject));
        // }
      });
      // forkJoin()
      forkJoin(subscriptionArray).subscribe(data => {
        data.forEach((chartData, index) => {
          this.appendDataToChartConfig(this.primaryCharts[index], 'primary', chartData);
        });
        this.updatedSubject.next('primary');
      });
    }
  }
  /**
  * format the chart data from service config for secondary chart
  * @param changeFor the application which is format for
  */
  formatSecondaryChart(changeFor) {
    if (this.secondaryCharts.length === 0) {
      this.updatedSubject.next('secondary');
    } else {
      const subscriptionArray = [];
      this.secondaryCharts.forEach(chart => {
        const serviceConfig = this.stockChartConfig.applicationConfig[chart].serviceConfig[changeFor];
        if (isEmptyField(serviceConfig.paramObject)) {
          serviceConfig.paramObject = {};
        }
        serviceConfig.paramObject = this.addFieldsToPostData(serviceConfig.paramObject, serviceConfig.additionalServiceParams, 'applicationAdditionalServiceParams');
        serviceConfig.paramObject.fromUnit = this.chartUnits && this.chartUnits.primary;
        subscriptionArray.push(this.stockChartCustomService[serviceConfig.functionName](this.applicationDataStore[chart], serviceConfig.paramObject));
      });
      // forkJoin()
      forkJoin(subscriptionArray).subscribe(data => {
        data.forEach((chartData, index) => {
          this.appendDataToChartConfig(this.primaryCharts[index], 'secondary', chartData);
        });
        this.updatedSubject.next('secondary');
      });
    }
  }





  /**
  * will call the primary chart related api / service
  */
  processPrimaryChart() {
    if (this.primaryForkArray.length === 0) {
      this.updatedSubject.next('primary');
      this.ngxLoader.stopLoader(this.loaderId.primary);

    } else {
      // this.removePrimaryCharts();
      forkJoin(this.primaryForkArray).subscribe(data => {
        let isSameUnit = true;
        if (!isEmptyField(this.stockCharFilterData.unit)) {
          isSameUnit = this.chartUnits.primary == this.stockCharFilterData.unit;
        }
        data.forEach((chartData, index) => {
          this.applicationDataStore[this.primaryForkArrayNames[index]] = chartData;
          if (isSameUnit) {
            this.appendDataToChartConfig(this.primaryForkArrayNames[index], 'primary');
          }
        });
        if (!isSameUnit) {
          this.formatPrimaryChart('unit');
        } else {
          this.updatedSubject.next('primary');
        }
        this.ngxLoader.stopLoader(this.loaderId.primary);
      });
    }
  }

  /**
  * will call the secondary chart related api / service
  */
  processSecondaryChart() {
    if (this.secondaryForkArray.length === 0) {
      this.updatedSubject.next('secondary');
      this.ngxLoader.stopLoader(this.loaderId.secondary);

    } else {
      // this.removeSecondaryCharts();
      forkJoin(this.secondaryForkArray).subscribe(data => {
        data.forEach((chartData, index) => {
          this.applicationDataStore[this.secondaryForkArrayNames[index]] = chartData;
          this.appendDataToChartConfig(this.secondaryForkArrayNames[index], 'secondary');
        });
        this.updatedSubject.next('secondary');
      });
      this.ngxLoader.stopLoader(this.loaderId.secondary);
    }
  }

  /**
  * will clear all the chart related data
  */
  clearChartData(from) {
    this.stockChartService.dataSubjectsList[this.stockChartId] = {};
    this.dataAPIs = [];
    this.primaryForkArray = [];
    this.secondaryForkArray = [];
    this.primaryForkArrayNames = [];
    this.secondaryForkArrayNames = [];
    if (this.stockChartRenderConfig && this.stockChartRenderConfig.series) {
      this.stockChartRenderConfig.series = [];
    }
    this.primaryCharts = [];
    this.secondaryCharts = [];
    this.stockChartRenderConfig.yAxis = [];
    this.chartUnitYAxisIndex.primary = {};
    this.chartUnitYAxisIndex.secondary = {};
  }





  /**
  * removing the all primary charts
  */
  removePrimaryCharts() {
    this.primaryCharts.forEach(chart => {
      const config = this.indicatorsConfig[chart];
      this.removeDataFromSeries(config.renderer + '_' + chart);
    });
  }

  /**
  * removing the all secondary charts
  */
  removeSecondaryCharts() {
    this.secondaryCharts.forEach(chart => {
      const config = this.indicatorsConfig[chart];
      this.removeDataFromSeries(config.renderer + '_' + chart);
    });
  }
  /**
  * return the unit for the chart
  * @param config deprecated
  * @param axis for which axis need the unit ex:: primary or secondary
  */
  getUnitForAxis(config, axis) {
    if (axis === 'secondary') {
      return config.unit;
    } else {
      if (!isEmptyField(this.stockCharFilterData.unit)) {
        return this.stockCharFilterData.unit;
      } else {
        return this.chartUnits.primary;
      }
    }
  }


  /**
  * append data to stock chart config
  * @param applicationName application Name which needs append to chart
  * @param axis axis means whether it is primary or secondary
  */
  appendDataToChartConfig(applicationName, axis, chartData?: any) {
    const config: ChartApplicationConfig = this.dataService.deepClone(this.stockChartConfig.applicationConfig[applicationName]);
    const renderConfig: StockChartRenderConfig = this.dataService.deepClone(this.indicatorsConfig[applicationName]);
    if (!Array.isArray(renderConfig.chartType)) {
      renderConfig.chartType = [renderConfig.chartType];
    }
    if (!Array.isArray(renderConfig.chartColor)) {
      renderConfig.chartColor = [renderConfig.chartColor];
    }

    renderConfig.chartType.forEach((chartType, index) => {
      this.addChartSeriesData(index, config, renderConfig, applicationName, axis, chartData);
    });
  }

  /**
  * add chart to series data
  * @param index chart type index
  * @param config chart application config
  * @param renderConfig application render config
  * @param applicationName application Name which needs append to chart
  * @param axis axis means whether it is primary or secondary
  * @param chartData chartData if any
  */
  addChartSeriesData(index, config: ChartApplicationConfig, renderConfig: StockChartRenderConfig, applicationName, axis, chartData) {
    const applicationIndex = Object.keys(this.indicatorsConfig).indexOf(applicationName);
    this.removeDataFromSeries(renderConfig.renderer + '_' + applicationName + '_' + renderConfig.chartType[index]);
    const actualChartData = !isEmptyField(chartData) ? this.dataService.deepClone(chartData) : this.dataService.deepClone(this.applicationDataStore[applicationName]);
    if (renderConfig.chartType[index] === 'areasplinerange') {
      actualChartData.forEach(seriesData => {
        seriesData.high = !isEmptyField(seriesData.areaMax) ? seriesData.areaMax : null;
        seriesData.low = !isEmptyField(seriesData.areaMin) ? seriesData.areaMin : null;
      });
    }

    const seriesDatConfig: any = {
      type: renderConfig.chartType[index],
      id: axis + '_' + applicationName + '_' + renderConfig.chartType[index],
      name: config.title,
      data: actualChartData,
      tooltip: {
        valueSuffix: ' ' + config.unit
      },
      yAxis: this.chartUnitYAxisIndex[axis][config.unit],
      zIndex: !isEmptyField(renderConfig.zIndex) ? renderConfig.zIndex : applicationIndex,
      // index: !isEmptyField(renderConfig.index) ? renderConfig.index : applicationIndex,
      visible: !isEmptyField(renderConfig.onLoadVisible) ? renderConfig.onLoadVisible : true,
      connectNulls: !isEmptyField(this.stockChartConfig.chartOptions.connectNulls) ? this.stockChartConfig.chartOptions.connectNulls : true
    };

    // if (axis === 'secondary') {
    // seriesDatConfig.yAxis = 1;
    // // if (!isEmptyField(config.chartType)) {
    // // seriesDatConfig.type = config.chartType;
    // // }
    // }

    if (renderConfig.chartColor) {
      seriesDatConfig.color = renderConfig.chartColor[index];
    }
    if (seriesDatConfig.type === 'area' || seriesDatConfig.type === 'areaspline') {
      seriesDatConfig.fillColor = {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [
          [0, Highcharts.color(seriesDatConfig.color).setOpacity(1).get('rgba')],
          [1, Highcharts.color(seriesDatConfig.color).setOpacity(0).get('rgba')]
        ]
      };
    }

    // if (seriesDatConfig.type === 'areasplinerange') {
    //   seriesDatConfig.fillColor = {
    //     linearGradient: {
    //       x1: 0,
    //       y1: 0,
    //       x2: 0,
    //       y2: 1
    //     },
    //     stops: [
    //       [0, Highcharts.color(seriesDatConfig.color).setOpacity(0.2).get('rgba')],
    //       // [1, Highcharts.color(seriesDatConfig.color).setOpacity(0).get('rgba')]
    //     ]
    //   };
    //   seriesDatConfig.lineWidth = 0.1;
    //   seriesDatConfig.showInLegend = false;
    //   seriesDatConfig.zIndex = applicationIndex - 1;
    // }

    if (seriesDatConfig.type === 'areasplinerange') {
      seriesDatConfig.fillColor = {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [
          [0, Highcharts.color(seriesDatConfig.color).setOpacity(0.3).get('rgba')],
          [1, Highcharts.color(seriesDatConfig.color).setOpacity(0.1).get('rgba')]
        ]
      };
      seriesDatConfig.lineWidth = 0.1;
      seriesDatConfig.showInLegend = false;
      seriesDatConfig.zIndex = applicationIndex - 1;
    }
    if (seriesDatConfig.type === 'candlestick') {
      seriesDatConfig.lineColor = '#ffff';
    }

    if (config.invertAxis) {
      if (renderConfig.renderer === 'primary') {
        this.stockChartRenderConfig.yAxis[0].reversed = true;
      }
      if (renderConfig.renderer === 'secondary') {
        this.stockChartRenderConfig.yAxis[1].reversed = true;
      }
    }
    this.stockChartRenderConfig.series.push(seriesDatConfig);
    this.chartIndexStore[applicationName] = this.stockChartRenderConfig.series.length - 1;
  }

  isArray(val) {
    return Array.isArray(val);
  }
  /**
  * will fire on checkbox click in indicators
  * @param applicationConfig application Indicator config on checkBox click
  */
  indicatorCheckBoxClick(event, applicationConfig: StockChartRenderConfig) {
    if (applicationConfig.renderer === 'secondary' && !this.stockChartConfig.chartOptions.secondaryChart) {
      this.dataService.showToastMessage('No secondary chart to render please select render as primary', 'error');
      event.preventDefault();
      return;
    }
    // event.preventDefault();
    // if (event.target.checked) {
    // const unitObject = this.verifyUnitObject(applicationConfig);
    // if (!unitObject.isSameUnit) {
    // const message = `${applicationConfig.renderer} chart units is ${unitObject.prevUnit} and ${applicationConfig.title} Unit is ${applicationConfig.unit}`;
    // this.dataService.showToastMessage(message, 'error');
    // event.preventDefault();
    // return;
    // }
    // } else {
    // if (applicationConfig.renderer === 'primary') {
    // if (this.primaryCharts.length === 1) {
    // this.chartUnits.primary = '';
    // }
    // }
    // if (applicationConfig.renderer === 'secondary') {
    // if (this.secondaryCharts.length === 1) {
    // this.chartUnits.secondary = '';
    // }
    // }
    // }
    applicationConfig.visible = !applicationConfig.visible;
    this.indicatorSubmit();
  }

  /**
  * will fire on indicator submit and fire all the initMethods()
  */
  indicatorSubmit(config?: StockChartRenderConfig) {
    /** for upgrading on update */
    // console.log(config, 'indicator here');
    // if (!isEmptyField(config) && !isEmptyObject(config)) {
    // config.visible = true;
    // }
    if (this.indicatorDropdown && this.indicatorDropdown.isOpen()) {
      this.indicatorDropdown.close();
    }
    if (this.childDropdown && this.childDropdown.length > 0) {
      this.childDropdown.forEach(dropdown => {
        if (dropdown.isOpen()) {
          dropdown.close();
        }
      });
    }
    this.updateRequireFields = [];
    this.updatedFieldsArray = [];
    this.initMethods('indicator');
  }
  /**
  * function to add or remove the indicator charts
  * @param indicator indicator config for respected application
  */
  addOrRemoveIndicatorCharts(indicator) {
    const renderConfig = this.indicatorsConfig[indicator];
    this.removeDataFromSeries(renderConfig.renderer + '_' + indicator);
    if (renderConfig.visible) {
      const chartData = null;
      let isSameUnit = true;
      if (!isEmptyField(this.stockCharFilterData.unit)) {
        isSameUnit = indicator.unit == this.stockCharFilterData.unit;
      }
      if (!isSameUnit && renderConfig.renderer === 'primary') {
        this.formatPrimaryChart('unit');
      } else {
        this.appendDataToChartConfig(indicator, renderConfig.renderer);
      }

    }
  }
  /**
  * reset indicators to default version
  */
  indicatorReset() {
    this.indicatorsConfig = this.dataService.deepClone(this.stockChartService.getIndicatorsConfig(this.stockChartConfig, this.geographicalStateObject));
    this.initMethods();
    // this.addOrRemoveAfterIndicatorChange();
  }
  /**
  * return the chart type for application Name from indicators config
  * @param applicationName application Name
  */
  getChartType(applicationName) {
    const config: ChartApplicationConfig = this.dataService.deepClone(this.stockChartConfig.applicationConfig[applicationName]);
    const renderConfig = this.indicatorsConfig[applicationName];
    if (renderConfig.chartType) {
      return renderConfig.chartType;
    }

    if (config.chartType) {
      return config.chartType;
    }

    return 'spline';
  }


  /**
  * return the postdata for application
  * @param application applicationName
  */
  getPostDataForApplication(application) {
    const applicationConfig: ChartApplicationConfig = this.dataService.deepClone(this.stockChartConfig.applicationConfig[application]);
    const apiConfig: StockChartApplicationAPIConfig = applicationConfig.apiConfig;
    apiConfig.postData = this.addFieldsToPostData(apiConfig.postData, applicationConfig.additionalPostParams, 'applicationAdditionalParams', applicationConfig.routerConfig, applicationConfig.geoGraphicObjectConfig);
    if (!isEmptyField(apiConfig.postDataFormatter) && !isEmptyObject(apiConfig.postDataFormatter)) {
      if (apiConfig.postDataFormatter.functionName) {
        try {
          apiConfig.postData = this.stockChartCustomService[apiConfig.postDataFormatter.functionName](apiConfig.postData, apiConfig.postDataFormatter.paramObject);
        } catch (e) {
          console.log('postdata formatter function error in stock chart service');
        }
      } else if (apiConfig.postDataFormatter.formatter) {
        apiConfig.postData = apiConfig.postDataFormatter.formatter(apiConfig.postData);
      }
    }
    return apiConfig;
  }
  /**
  * reset the application data store (clear the local store)
  */
  resetApplicationDataStore() {
    for (const application of Object.keys(this.applicationDataStore)) {
      this.applicationDataStore[application] = {};
    }
  }
  /**
  * fire when the filter value change
  * @param value changed field from the filter
  * @param config respected config of the filter
  */
  filterValueChange(value, config) {
    this.updateRequireFields = [];
    this.updatedFieldsArray = [];
    if (config.changeFireEventType && config.changeFireEventType == 'none') {
      return;
    }
    switch (value) {
      case 'chartTheme':
        this.chartThemeChange(value);
        break;
    }
    if (config.changeFireEventType === 'api') {
      this.resetApplicationDataStore();
      if (config.functionsFireOnChange === 'all') {
        this.updateRequireFields = JSON.parse(JSON.stringify(this.allUpdateFieldArray));
      } else {
        this.updateRequireFields = JSON.parse(JSON.stringify(config.functionsFireOnChange));
      }
      this.processIndicatorData();
      this.callAPIBasedOnInput(this.updateRequireFields);
    }

    if (config.changeFireEventType === 'service') {
      if (config.functionsFireOnChange === 'all') {
        this.updateRequireFields = JSON.parse(JSON.stringify(this.allUpdateFieldArray));
      } else {
        this.updateRequireFields = JSON.parse(JSON.stringify(config.functionsFireOnChange));
      }
      this.callServiceBasedOnInput(this.updateRequireFields, value);
    }
  }
  /**
  * fire when chart theme filter changes
  * @param theme chart theme
  */
  chartThemeChange(theme) {
    this.stockChartRenderConfig = Highcharts.merge(this.stockChartRenderConfig, this.themeConfig[this.stockCharFilterData[theme]]);
    // Highcharts.setOptions(this.themeConfig[this.stockCharFilterData[theme]]);
    this.updateChartConfig();
  }
  /**
  * will update the chart configuration
  */
  updateChartConfig() {
    this.updateStockChartLabels();
    this.stockChartRenderConfig.series.sort((a, b) => this.chartOrder.indexOf(a.id.split('_')[0]) > this.chartOrder.indexOf(b.id.split('_')[0]) ? 1 : -1);
    let dataObject = {
      filter: this.stockCharFilterData,
      datePicker: this.stockChartDatePickerData,
      config: this.stockChartRenderConfig
    };
    this.configDataEmitter.emit(dataObject);
    setTimeout(() => {
      this.stockChartService.updateStockChartConfigData(this.stockChartId, this.stockChartRenderConfig);
    }, 100);
  }
  /**
  * will remove the chart from the series
  * @param id chart series id to remove
  */
  removeDataFromSeries(id) {
    const index = this.stockChartRenderConfig.series.findIndex(val => val.id === id);
    if (index != -1) {
      this.stockChartRenderConfig.series.splice(index, 1);
    }
  }
  /**
  * will generate the postData from the configuration
  * @param postData the current postData which data will append
  * @param fieldsNeedToAdd addition fields need to add to postData
  * @param applicationRouterConfig router config which might need to add postdata from the router
  */
  addFieldsToPostData(postData, fieldsNeedToAdd, paramObjectName, applicationRouterConfig?, geoObject?) {
    const fieldsToBeAdded = {};
    if (fieldsNeedToAdd == 'all') {
      fieldsNeedToAdd = this.stockChartConfig[paramObjectName];
    } else if (fieldsNeedToAdd == 'none') {
      fieldsNeedToAdd = {};
    } else {
      fieldsNeedToAdd = this.getNeedFields(fieldsNeedToAdd);
    }
    for (const fieldType of Object.keys(fieldsNeedToAdd)) {
      let dataSource: any;
      if (fieldType === 'filter') {
        dataSource = this.stockCharFilterData;
      } else if (fieldType === 'date') {
        dataSource = this.stockChartDatePickerData;
      } else {
        dataSource = this.otherSubscriptionsData[fieldType];
      }
      for (const fieldValue of Object.keys(fieldsNeedToAdd[fieldType])) {
        if (!isEmptyObject(dataSource) && !isEmptyField(dataSource[fieldValue])) {
          postData[fieldsNeedToAdd[fieldType][fieldValue]] = dataSource[fieldValue];
        }
      }
    }
    const routerConfig: any = !!applicationRouterConfig ? applicationRouterConfig : !!this.stockChartConfig.routerConfig ? this.stockChartConfig.routerConfig : {};

    if (!isEmptyObject(routerConfig)) {
      if (!isEmptyObject(routerConfig.queryParam)) {
        for (const param of Object.keys(routerConfig.queryParam)) {
          if (!isEmptyField(this.route.snapshot.queryParams[param])) {
            postData[routerConfig.queryParam[param]] = this.route.snapshot.queryParams[param];
          }
        }
      }

      if (!isEmptyObject(routerConfig.paramMap)) {
        for (const param of Object.keys(routerConfig.paramMap)) {
          if (!isEmptyField(this.route.snapshot.params[param])) {
            postData[routerConfig.paramMap[param]] = this.route.snapshot.params[param];
          }
        }
      }
    }
    if (!isEmptyField(geoObject) && !isEmptyObject(geoObject)) {
      for (const param of Object.keys(geoObject)) {
        if (!isEmptyField(this.geographicalStateObject[param])) {
          postData[geoObject[param]] = this.geographicalStateObject[param];
        }
      }
    }
    return postData;
  }
  /**
  * will add the postData fields from config string
  * @param fieldsNeedToAdd fieldsToAdd string if fields not equal to all
  */
  getNeedFields(fieldsNeedToAdd: string) {
    const needFieldObject = {};
    const needFields = fieldsNeedToAdd.split('$$');
    needFields.forEach(field => {
      const fieldType = field.split('##')[0];
      const fieldValue = field.split('##')[1];
      if (isEmptyObject(needFieldObject[fieldType])) {
        needFieldObject[fieldType] = {};
      }
      needFieldObject[fieldType][fieldValue] = this.stockChartConfig.applicationAdditionalParams[fieldType][fieldValue];
    });
    return needFieldObject;
  }


  // Chart related functions
  /**
  * Simple moving average modal
  */
  openSMAModal() {
    const smaModal = this.ngbModal.open(SmaModelComponent, {
      size: 'sm',
    });
    smaModal.componentInstance.formValue = this.smaValue;
    smaModal.result.then(data => {
      this.smaValue = data;
      if (this.smaValue.showSMA) {
        if (this.primaryCharts.length === 0) {
          this.dataService.showToastMessage('No primary chart to render sma', 'error');
          return;
        }
        this.addOrRemoveSMAFromChart(this.smaValue.numberOfDays, 'add');
      } else {
        this.addOrRemoveSMAFromChart(null, 'remove');
      }
    });
  }
  /**
  * add or remove sma chart
  * @param numberOfDays number of days for simple moving average
  * @param type add or remove
  */
  addOrRemoveSMAFromChart(numberOfDays, type) {
    if (type == 'add') {
      const seriesConfig = {
        name: 'SMA for' + this.stockChartConfig.applicationConfig[this.primaryCharts[0]].title + ' of ' + numberOfDays,
        type: 'sma',
        id: 'sma',
        chartType: 'spline',
        linkedTo: 'primary_' + this.primaryCharts[0],
        marker: {
          enabled: false
        },
        params: {
          period: convertToInt(numberOfDays)
        }
      };
      this.stockChartRenderConfig.series.push(seriesConfig);
    } else {
      const index = this.stockChartRenderConfig.series.findIndex(val => val.id == 'sma');
      if (index >= 0) {
        this.stockChartRenderConfig.series.splice(index, 1);
      }
    }
    this.updateChartConfig();
  }
  /**
  * will set the default config for chart in future we can get this from the config
  */
  setChartDefaultConfig() {
    const controller = this;
    this.stockChartRenderConfig = {
      chart: {
        backgroundColor: '#171e28'
      },
      credits: {
        enabled: false
      },
      time: {
        useUTC: false,
        timezone: 'Asia/Kolkata'
      },
      xAxis: [
        {
          type: 'datetime',
          ordinal: false,
          dateTimeLabelFormats: {
            millisecond: '%d-%b<br>%Y',
            second: '%d-%b<br>%Y',
            minute: '%d-%b<br>%Y',
            hour: '%d-%b<br>%Y',
            day: '%d-%b<br>%Y',
            week: '%d-%b<br>%Y',
            month: '%d-%b<br>%Y',
            year: '%d-%b<br>%Y'
          },
        }
      ],
      navigator: {
        enabled: true,
        height: 10,
        series: {
          lineWidth: 0,
          fillOpacity: 0,
          type: 'line'
        },
        xAxis: {
          labels: {
            enabled: false
          },
          ordinal: false,
          type: 'datetime',
          dateTimeLabelFormats: {
            millisecond: '%d-%b<br>%Y',
            second: '%d-%b<br>%Y',
            minute: '%d-%b<br>%Y',
            hour: '%d-%b<br>%Y',
            day: '%d-%b<br>%Y',
            week: '%d-%b<br>%Y',
            month: '%d-%b<br>%Y',
            year: '%d-%b<br>%Y'
          }
        }
      },
      yAxis: [
        // {
        // labels: {
        // align: 'left',
        // useHTML: true
        // },
        // height: '80%',
        // // resize: {
        // // enabled: true
        // // },
        // opposite: true,
        // },
        // {
        // gridLineWidth: 0,
        // labels: {
        // align: 'left',
        // useHTML: true
        // },
        // height: '80%',
        // // top: '80%',
        // // height: '20%',
        // // offset: 0,
        // opposite: false
        // },
        // {
        // gridLineWidth: 0,
        // labels: {
        // align: 'left',
        // useHTML: true
        // },
        // top: '80%',
        // height: '20%',
        // offset: 0,
        // opposite: false
        // },
      ],
      // tooltip: {
      // backgroundColor: 'white',
      // borderWidth: 0,
      // borderRadius: 0,
      // headerFormat: '{point.key} ',
      // // pointFormat: ' | <span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b>',
      // // positioner: function () {
      // // return { x: 10, y: 35 };
      // // },
      // shadow: false,
      // split: false
      // },

      tooltip: {
        shape: 'square',
        headerShape: 'callout',
        borderWidth: 0,
        shadow: false,
        enabled: true,
        split: true,
        shared: true,
        useHTML: true,
        valueDecimals: 2,
        formatter: function () {
          let s = '<b>' + Highcharts.dateFormat('%A, %d %b, %Y', this.x) + '</b><br>';
          if(controller.stockChartConfig.chartId == 'GroundWaterMIS' || controller.stockChartConfig.chartId == 'GROUNDWATERGIS' ){
              let customLabel ='';
              let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
              let selectedInterval = controller.stockChartConfig.chartOptions.xAxis.intervalPeriod;
              let currrentDate = new Date(this.x);
              let newMillis = 1000 * 60 * 60 * 24 * selectedInterval*32 + this.x;
              let newDate = new Date(newMillis);
              customLabel = months[currrentDate.getMonth()] +'-'+ months[newDate.getMonth()]+" "+ currrentDate.getFullYear();
              s = '<b>' +customLabel + '</b><br>';
          }

          let seriesName = '';
          this.points.forEach((point) => {
            let suffix = !!point.series.userOptions ? !!point.series.userOptions.tooltip ? !!point.series.userOptions.tooltip.valueSuffix ? point.series.userOptions.tooltip.valueSuffix : '' : '' : '';
            if (point.series.pointArrayMap && point.series.pointArrayMap.length > 1 && (point.series.type === 'candlestick' || point.series.type === 'areasplinerange')) {
              if (seriesName != point.series.name) {
                s += '<br/><b>' + point.series.name + '</b> <br>';
              }
              seriesName = point.series.name;
              point.series.pointArrayMap.forEach(element => {
                let elementName: string = element;
                if (point.series.type === 'areasplinerange') {
                  elementName = element === 'high' ? 'Normal Max' : 'Normal Min';
                }
                if (point.series.type === 'candlestick') {
                  if (element === 'open' || element === 'close') {
                    elementName = element === 'open'? 'Actual Max':'Actual Min';
                    s += '&nbsp&nbsp&nbsp' + controller.stockChartCustomService.titleCase(elementName) + ': ' + point.point[element] + '' + suffix + '<br>';
                  }
                  // else {
                    // s += '&nbsp&nbsp&nbsp' + controller.stockChartCustomService.titleCase(elementName) + ':' + point.point[element] + '' + suffix + '<br>';
                  // }
                } else {
                  s += '&nbsp&nbsp&nbsp' + controller.stockChartCustomService.titleCase(elementName) + ': ' + point.point[element] + '' + suffix + '<br>';
                }
              });
            } else {
              // console.log("\n point.series \n ", point.series);
              s += '<br/><span style="color:' + point.series.color + ';">\u25CF </span>' + point.series.name + ': <b>' + controller.stockChartCustomService.formatNumber(point.y) + '' + suffix + '</b>';
            }
            //
          });
          return s;
        },
        // valueSuffix: ' mm',
        positioner: function (width, height, point) {
          let chart = this.chart;
          let position;
          if (point.isHeader) {
            position = {
              x: Math.max(
                // Left side limit
                chart.plotLeft,
                Math.min(
                  point.plotX + chart.plotLeft - width / 2,
                  // Right side limit
                  chart.chartWidth - width - chart.marginRight
                )
              ),
              y: point.plotY
            };
          } else {
            position = {
              x: point.series.chart.plotLeft,
              y: point.series.yAxis.top - chart.plotTop
            };
          }
          return position;
        }
      },
      legend: {
        enabled: true,
        itemStyle: {
          color: '#ffffff'
        }
      },
      plotOptions: {
        flags: {
          showInLegend: false
        },
        column: {
          grouping: true,
        }
      },

      stockTools: {
        gui: {
          enabled: false,
          buttons: ['separator', 'measure', 'toggleAnnotations', 'separator', 'flags', 'separator',
 /*'zoomChange', 'fullScreen','lines', 'separator', */ 'crookedLines', 'simpleShapes', 'verticalLabels', 'separator'
          ],
          definitions: {
            measure: {
              items: ['measureX', 'measureY']
            },
            simpleShapes: {
              items: ['label', 'circle']
            },
            verticalLabels: {
              items: ['verticalLabel', 'verticalArrow']
            }
          }
        }
      },
      rangeSelector: {
        enabled: true,
        inputEnabled: false,
        selected: 10,
        buttons: [
          {
            type: 'day',
            count: 5,
            text: '5d',
            timeRangeInMillis: 432000000,
          }, {
            type: 'week',
            count: 1,
            text: '1w',
            timeRangeInMillis: 604800000,
          }, {
            type: 'day',
            count: 15,
            text: '15d',
            timeRangeInMillis: 1296000000,
          }, {
            type: 'month',
            count: 1,
            text: '1m',
            timeRangeInMillis: 2592000000,
          }, {
            type: 'month',
            count: 3,
            text: '3m',
            timeRangeInMillis: 7776000000,
          }, {
            type: 'month',
            count: 6,
            text: '6m',
            timeRangeInMillis: 15552000000,
          }, {
            type: 'year',
            count: 1,
            text: '1y',
            timeRangeInMillis: 31536000000,
          }, {
            type: 'mytd',
            text: 'MYTD'
          }, {
            type: 'ytd',
            text: 'YTD',
            // timeRangeInMillis:0,
          }, {
            type: 'all',
            text: 'All',
          }
        ]
      },
      series: [],
      responsive: {
        rules: [{
          condition: {
            maxWidth: 800
          },
          chartOptions: {
            rangeSelector: {
              inputEnabled: false
            }
          }
        }]
      }
    };
    this.formatDefaultConfig();
  }

  formatDefaultConfig() {
    const chartOptions: StockChartOptions = this.stockChartConfig.chartOptions;
    if (!isEmptyField(chartOptions.rangeSelector) && !chartOptions.rangeSelector) {
      this.stockChartRenderConfig.rangeSelector.enabled = false;
    }
    // if (!isEmptyField(chartOptions.secondaryChart) && !chartOptions.secondaryChart) {
    // this.stockChartRenderConfig.yAxis[0].height = '100%';
    // }

    if (!isEmptyField(chartOptions.navigator) && !chartOptions.navigator) {
      this.stockChartRenderConfig.navigator.enabled = false;
    }

    if (!isEmptyField(chartOptions.scrollbar) && !chartOptions.scrollbar) {
      this.stockChartRenderConfig.scrollbar = {};
      this.stockChartRenderConfig.scrollbar.enabled = false;
    }


    // if (!isEmptyField(chartOptions.yAxis)) {
    // if (chartOptions.yAxis.labelsAlignment === 'left') {
    // this.stockChartRenderConfig.yAxis[0].labels.align = 'right';
    // this.stockChartRenderConfig.yAxis[0].opposite = false;
    // }
    // }

    if (!isEmptyField(chartOptions.hideDataGaps) && chartOptions.hideDataGaps) {
      this.stockChartRenderConfig.xAxis[0].ordinal = true;
    }
    this.updateStockChartLabels();
  }

  updateStockChartLabels() {
    for (let dateLabel of this.getHeaders(this.stockChartRenderConfig.xAxis[0].dateTimeLabelFormats)) {
      this.stockChartRenderConfig.xAxis[0].dateTimeLabelFormats[dateLabel] = this.getLabelForxAxis(this.stockChartConfig.chartOptions, dateLabel, this.stockChartRenderConfig.xAxis[0].dateTimeLabelFormats[dateLabel]);
    }
    if (this.stockChartRenderConfig.navigator && this.stockChartRenderConfig.navigator.xAxis && this.stockChartRenderConfig.navigator.xAxis.dateTimeLabelFormats) {
      this.stockChartRenderConfig.navigator.xAxis.dateTimeLabelFormats = this.stockChartRenderConfig.xAxis[0].dateTimeLabelFormats;
    }
    let controller = this;
    if ( !isEmptyField(this.stockChartConfig.chartOptions.xAxis.intervalPeriod)) {
      this.stockChartRenderConfig.xAxis[0].labels = {
        formatter: function () {
          let customLabel ='';
          let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          let selectedInterval = controller.stockChartConfig.chartOptions.xAxis.intervalPeriod;
          let currrentDate = new Date(this.value);
          let newMillis = 1000 * 60 * 60 * 24 * selectedInterval*32 + this.value;
          let newDate = new Date(newMillis);
          customLabel = months[currrentDate.getMonth()] +'-'+ months[newDate.getMonth()]+" "+ currrentDate.getFullYear();
          this.value = customLabel;
          return this.value;
        }
      }
    }
    // if (this.stockChartConfig.chartOptions.yAxis.unitAsTitle) {
    // this.stockChartRenderConfig.yAxis[0].title = {};
    // this.stockChartRenderConfig.yAxis[0].title.text = this.getUnitForAxis({}, 'primary');
    // if (this.stockChartConfig.chartOptions.secondaryChart) {
    // this.stockChartRenderConfig.yAxis[1].title = {
    // offset: 20
    // };
    // this.stockChartRenderConfig.yAxis[1].title.text = this.getUnitForAxis({}, 'secondary');
    // }
    // }
    // if (this.secondaryCharts.length === 0) {
    // this.stockChartRenderConfig.yAxis[0].height = '100%';
    // if (isEmptyField(this.stockChartRenderConfig.yAxis[0].resize)) {
    // this.stockChartRenderConfig.yAxis[0].resize = {};
    // }
    // this.stockChartRenderConfig.yAxis[0].resize.enabled = false;
    // } else {
    // // this.stockChartRenderConfig.yAxis[0].height = '80%';
    // // if (isEmptyField(this.stockChartRenderConfig.yAxis[0].resize)) {
    // // this.stockChartRenderConfig.yAxis[0].resize = {};
    // // }
    // // this.stockChartRenderConfig.yAxis[0].resize.enabled = true;
    // }
    // if (this.stockChartConfig.chartOptions.yAxis.labelsFormatter) {
    // const controller = this;
    // this.stockChartRenderConfig.yAxis[0].labels.formatter = function() {
    // const unit = controller.({}, 'primary');
    // if (controller.stockChartConfig.chartOptions.yAxis.labelsFormatter.functionName) {
    // try {
    // const formatter = controller.stockChartCustomService[controller.stockChartConfig.chartOptions.yAxis.labelsFormatter.functionName](this.value, unit, controller.stockChartConfig.chartOptions.yAxis);
    // return formatter;
    // } catch (e) {
    // console.log('Y axis label formatter function not exists');
    // }
    // } else if (controller.stockChartConfig.chartOptions.yAxis.labelsFormatter.formatter) {
    // return controller.stockChartConfig.chartOptions.yAxis.labelsFormatter.formatter;
    // }
    // };
    // // this.stockChartRenderConfig.yAxis[0].labels.format = '{value} ' + this.getUnitForAxis({}, 'primary');
    // this.stockChartRenderConfig.yAxis[1].labels.formatter = function() {
    // const unit = controller.getUnitForAxis({}, 'secondary');
    // if (controller.stockChartConfig.chartOptions.yAxis.labelsFormatter.functionName) {
    // try {
    // const formatter = controller.stockChartCustomService[controller.stockChartConfig.chartOptions.yAxis.labelsFormatter.functionName](this.value, unit, controller.stockChartConfig.chartOptions.yAxis);
    // return formatter;
    // } catch (e) {
    // console.log('Y axis label formatter function not exists');
    // }
    // } else if (controller.stockChartConfig.chartOptions.yAxis.labelsFormatter.formatter) {
    // return controller.stockChartConfig.chartOptions.yAxis.labelsFormatter.formatter;
    // }
    // };
    // }
    if (!this.stockChartConfig.chartOptions.scrollbar) {
      this.stockChartRenderConfig.scrollbar = {};
      this.stockChartRenderConfig.scrollbar.enabled = false;
    }
    if (!this.stockChartConfig.chartOptions.navigator) {
      this.stockChartRenderConfig.navigator = {};
      this.stockChartRenderConfig.navigator.enabled = false;
    } else {
      if (!this.stockChartRenderConfig.navigator) {
        this.stockChartRenderConfig.navigator = {};
      }
      this.stockChartRenderConfig.navigator.height = 10;
      this.stockChartRenderConfig.navigator.series = {
        lineWidth: 0,
        fillOpacity: 0,
        type: 'line'
      };
    }
  }

  getLabelForxAxis(options: StockChartOptions, configLabel, actualLabel) {
    const timeIntervalField = this.stockChartConfig.chartOptions ? this.stockChartConfig.chartOptions.timeIntervalField ? this.stockChartConfig.chartOptions.timeIntervalField : 'timeInterval' : 'timeInterval';
    if (this.stockCharFilterData && this.stockCharFilterData[timeIntervalField]) {
      if (this.stockChartConfig.chartOptions.xAxis && this.stockChartConfig.chartOptions.xAxis.timeIntervalConfig && this.stockChartConfig.chartOptions.xAxis.timeIntervalConfig[this.stockCharFilterData[timeIntervalField]]) {
        return this.stockChartConfig.chartOptions.xAxis.timeIntervalConfig[this.stockCharFilterData[timeIntervalField]];
      }
    }
    if (options.xAxis && options.xAxis.labelFormats && options.xAxis.labelFormats.dateTimeLabelFormats && options.xAxis.labelFormats.dateTimeLabelFormats[configLabel]) {
      return options.xAxis.labelFormats.dateTimeLabelFormats[configLabel];
    }
    if (!isEmptyField(options.xAxis.labelFormats.common)) {
      return options.xAxis.labelFormats.common;
    }
    return actualLabel;
  }
}
